const {registerBlockType} = wp.blocks;
const {InspectorControls, MediaUpload, MediaUploadCheck, RichText, URLInputButton} = wp.blockEditor;
const {PanelBody, Button, ResponsiveWrapper} = wp.components;
const {Fragment, useEffect} = wp.element;
const {withSelect} = wp.data;
const {__} = wp.i18n;
import {heroPlatformAnimation, loadedAnimation} from '../../../resources/scripts/module/hero-platform';

const BlockEdit = (props) => {
  const {attributes, setAttributes} = props;
  const {linkText, linkUrl} = attributes;

  const removeMedia = (type, media) => {
    if (type === 'desktop') {
      props.setAttributes({
        desktopMediaId: 0,
        desktopMediaUrl: ''
      });
    } else if (type === 'mobile') {
      props.setAttributes({
        mobileMediaId: 0,
        mobileMediaUrl: ''
      });
    }
  }

  const onSelectMedia = (type, media) => {
    if (type === 'desktop') {
      props.setAttributes({
        desktopMediaId: media.id,
        desktopMediaUrl: media.url
      });
    } else if (type === 'mobile') {
      props.setAttributes({
        mobileMediaId: media.id,
        mobileMediaUrl: media.url
      });
    }
  }

  useEffect(() => {
    heroPlatformAnimation();

    return () => {
      if (loadedAnimation) {
        loadedAnimation.destroy();
      }
    };
  });

  return (
    <Fragment>
      <InspectorControls>
        <PanelBody
          title={__('Set JSON animations ', 'editor')}
          initialOpen={true}
        >
          <div className="editor-post-animations">
            <MediaUploadCheck>
              <MediaUpload
                onSelect={onSelectMedia.bind(this, 'desktop')}
                value={attributes.desktopMediaId}
                allowedTypes={['json']}
                render={({open}) => (
                  <Button
                    className={attributes.desktopMediaId === 0 ? 'editor-post-animation-desktop__toggle' : 'editor-post-featured-animation-desktop__preview'}
                    onClick={open}
                  >
                    {attributes.desktopMediaId === 0 && __('Choose Desktop Animation', 'editor')}
                    {props.desktopMedia !== undefined &&
                      <ResponsiveWrapper>
                        <span style={{display: 'inline-block'}}>{props.desktopMedia.source_url}</span>
                      </ResponsiveWrapper>
                    }
                  </Button>
                )}
              />
              {attributes.desktopMediaId !== 0 && (
                <>
                  <MediaUpload
                    title={__('Replace Desktop Animation', 'editor')}
                    value={attributes.desktopMediaId}
                    onSelect={onSelectMedia.bind(this, 'desktop')}
                    allowedTypes={['json']}
                    render={({open}) => (
                      <Button onClick={open} isDefault isLarge>{__('Replace Desktop Animation', 'editor')}</Button>
                    )}
                  />
                  <Button onClick={removeMedia.bind(this, 'desktop')} isLink
                          isDestructive>{__('Remove Desktop Animation', 'editor')}</Button>
                </>
              )
              }
            </MediaUploadCheck>
            <hr/>
            <MediaUploadCheck>
              <MediaUpload
                onSelect={onSelectMedia.bind(this, 'mobile')}
                value={attributes.mobileMediaId}
                allowedTypes={['json']}
                render={({open}) => (
                  <Button
                    className={attributes.mobileMediaId === 0 ? 'editor-post-animation-mobile__toggle' : 'editor-post-featured-animation-mobile__preview'}
                    onClick={open}
                  >
                    {attributes.mobileMediaId === 0 && __('Choose Mobile Animation', 'editor')}
                    {props.mobileMedia !== undefined &&
                      <ResponsiveWrapper>
                        <span style={{display: 'inline-block'}}>{props.mobileMedia.source_url}</span>
                      </ResponsiveWrapper>
                    }
                  </Button>
                )}
              />
              {attributes.mobileMediaId !== 0 && (
                <>
                  <MediaUpload
                    title={__('Replace Mobile Animation', 'editor')}
                    value={attributes.mobileMediaId}
                    onSelect={onSelectMedia.bind(this, 'mobile')}
                    allowedTypes={['json']}
                    render={({open}) => (
                      <Button onClick={open} isDefault isLarge>{__('Replace Mobile Animation', 'editor')}</Button>
                    )}
                  />
                  <Button onClick={removeMedia.bind(this, 'mobile')} isLink
                          isDestructive>{__('Remove Mobile Animation', 'editor')}</Button>
                </>
              )
              }
            </MediaUploadCheck>
          </div>
        </PanelBody>
      </InspectorControls>
      <div className={'platform-top'}>
        <div className={'inner'}>
          <div className={'platform-top-info'}>
            <RichText
              tagName="h1"
              value={attributes.header}
              onChange={(newHeader) => setAttributes({header: newHeader})}
            />
            <RichText
              tagName="p"
              value={attributes.info}
              onChange={(newInfo) => setAttributes({info: newInfo})}
            />

            <a href={'#'} className={'home-info-link'} title={attributes.linkUrl}>
              <RichText
                tagName="span"
                value={attributes.linkText}
                onChange={(newLinkText) => setAttributes({linkText: newLinkText})}
              />
              <URLInputButton
                url={linkUrl}
                onChange={(newUrl) => setAttributes({linkUrl: newUrl})}
              />
            </a>
          </div>
          <div data-src={attributes.desktopMediaUrl}
               data-mobile-src={attributes.mobileMediaUrl}
               id="platform-top-animation"
               className="platform-top-animation"/>
        </div>
      </div>
    </Fragment>
  );
};


registerBlockType('mailmetrics/platform-hero-top', {
  title: 'Platform Hero Top',
  icon: 'smiley',
  category: 'layout',
  supports: {
    align: true,
    html: false,
  },
  attributes: {
    header: {
      type: 'string',
      source: 'html',
      selector: 'h1',
      default: 'The enterprise platform for<br/>essential customer comms'
    },
    info: {
      type: 'string',
      source: 'html',
      selector: 'p',
      default: 'Mail Metrics makes your most vital customer comms visible, digital, and powerful. A&nbsp;blend of expert advice and powerful software, it’s a single solution for creating, sorting, sending, and receiving highly-regulated comms like statements and renewal notices. Across your customer lifecycle, on any channel, and at enterprise scale.'
    },
    linkUrl: {
      type: 'string',
      default: ''
    },
    linkText: {
      type: 'string',
      default: 'Explore the platform'
    },
    desktopMediaId: {
      type: 'number',
      default: 0
    },
    desktopMediaUrl: {
      type: 'string',
      default: ''
    },
    mobileMediaId: {
      type: 'number',
      default: 0
    },
    mobileMediaUrl: {
      type: 'string',
      default: ''
    }
  },
  edit: withSelect((select, props) => {
    return {
      desktopMedia: props.attributes.desktopMediaId ? select('core').getMedia(props.attributes.desktopMediaId) : undefined,
      mobileMedia: props.attributes.mobileMediaId ? select('core').getMedia(props.attributes.mobileMediaId) : undefined,
    };
  })(BlockEdit),
  save: (props) => {
    const {attributes} = props;
    const {linkText, linkUrl} = attributes;

    return (
      <div className={'platform-top'}>
        <div className="inner">
          <div className={'platform-top-info'}>
            <RichText.Content tagName="h1" value={attributes.header}/>
            <RichText.Content tagName="p" value={attributes.info}/>
            <a href={linkUrl}>
              <span>{linkText}</span>
            </a>
          </div>
          <div data-mobile-src={attributes.mobileMediaUrl}
               data-src={attributes.desktopMediaUrl}
               id="platform-top-animation"
               className="platform-top-animation"/>
        </div>
      </div>
    );
  }
});
